import { Form, type FormProps, Modal, Typography, Flex } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'

import { type CouponBody, CouponService } from '@services/CouponService'
import { useNotifications } from '@store/notifications'

import type { Product } from '../../../../types'

import { CouponForm } from './CouponForm'

type ModalProps = {
    isOpen: boolean
    onClose: () => void
    onSuccess: () => Promise<void>
    availableProducts: Product[]
}

export const AddCouponModal: React.FC<ModalProps> = ({ isOpen, onClose, onSuccess, availableProducts }) => {
    const { showNotification } = useNotifications()
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm()

    useEffect(() => {
        form.setFieldsValue({
            code: '',
            expiry: dayjs().add(7, 'days'),
            productId: null
        })
    }, [form])

    const onFinish: FormProps<CouponBody>['onFinish'] = async values => {
        const body: CouponBody = {
            code: values.code.toLowerCase().trim(),
            expiry: values.expiry,
            productId: values.productId
        }
        try {
            setIsLoading(true)
            await CouponService.create(body)
            showNotification({ title: 'Coupon successully added' })
            await onSuccess()
            onClose()
        } catch (err: any) {
            const message = err.response.data ? err.response.data : err.toString()
            showNotification({ title: 'Could not add the coupon', type: 'error', description: message })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal open={isOpen} footer={[]} onCancel={onClose}>
            <Flex vertical gap="middle">
                <Typography.Title level={4}>Edit a coupon</Typography.Title>
                <CouponForm
                    form={form}
                    onFinish={onFinish}
                    availableProducts={availableProducts}
                    isLoading={isLoading}
                />
            </Flex>
        </Modal>
    )
}
